/*global initPopupCloseFunction*/
/*eslint @typescript-eslint/no-explicit-any:0 */
/* TODO: replace any (object might work but currently not recommended due to typescript issue) */
import { initPopupCloseFunction } from './popup';
$('.ts-get-communication-info').on('click', function () {
    var id = $(this).data('id');
    $.get({
        url: '/kommunikation/info?id=' + id
    }).done(function (response) {
        var element = $('#news-popup');
        updateNumberUnreadMessages();
        var teaser = $('#' + id);
        if (teaser) {
            if (teaser.hasClass('unread')) {
                teaser.removeClass('unread').addClass('read');
            }
        }
        if (element) {
            element.parent().replaceWith(response);
            initPopupCloseFunction();
            $('#news-popup').parent().addClass('visible');
        }
    });
});
function updateNumberUnreadMessages() {
    $.get({
        url: '/kommunikation/numberunreadmessages'
    }).done(function (response) {
        var element = $('.number-unread-messages');
        if (element) {
            element.html(response);
            $('.number-unread-messages').attr('value', response);
        }
    });
}
